import { plainToClass } from 'class-transformer';
import {
  API_INTERNAL_WORK_TYPE_CREATE,
  API_INTERNAL_WORK_TYPE_DELETE,
  API_INTERNAL_WORK_TYPE_FIND_ALL,
  API_INTERNAL_WORK_TYPE_FIND_ONE,
  API_INTERNAL_WORK_TYPE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { InternalWorkTypeDto } from '../dto';
import { FindAllResponse } from '../types';

export class InternalWorkTypeApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<InternalWorkTypeDto>> {
    return this.httpClient
      .get(API_INTERNAL_WORK_TYPE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(InternalWorkTypeDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<InternalWorkTypeDto> {
    return this.httpClient
      .get(API_INTERNAL_WORK_TYPE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(InternalWorkTypeDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<InternalWorkTypeDto> {
    return this.httpClient
      .post(API_INTERNAL_WORK_TYPE_CREATE, data)
      .then(({ data }) => {
        return plainToClass(InternalWorkTypeDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<InternalWorkTypeDto> {
    return this.httpClient
      .put(API_INTERNAL_WORK_TYPE_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(InternalWorkTypeDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_INTERNAL_WORK_TYPE_DELETE, {
      pathParams: { uuid }
    });
  }
}
